export const CheckIcon = require('./check-scallop.svg')
export const CalculatorIcon = require('./calculator.svg')
export const TransferIcon = require('./transfer.svg')
export const QuestionIcon = require('./question.svg')
export const StopwatchIcon = require('./stopwatch.svg')
